import React from "react";
import { Link } from "react-router-dom";

import Page from "../../../../components/Page";
import OrderableQuestionnaires from "../../components/OrderableQuestionnaires";
import Icon from "../../../../components/Icon";
import { translations } from "../../../../config";

/**
 * Komponente um statische Inhalte auszugeben
 */
class Prices extends React.Component
{
	render()
	{
		const { orderableQuestionnaires } = { ...this.props };
		
		return <Page title={"Das Imera Preismodell"} pageUrl={"/preise"}>
			<div className={"col s12 unset-padding"}>
				<div className={"col s12 xl4"}>
					<h3>Fair</h3>
					<p>Mit Imera haben wir die jahrzehntelange Erfahrung von Top-Experten in diesem digitalen Service effizient auf den Punkt gebracht.
						Ingenieur-Knowhow zum fairen Preis.</p>
				</div>
				<div className={"col s12 xl4"}>
					<h3>Bedarfsgerecht</h3>
					<p>Die Kosten von Imera richten sich danach, wie intensiv Sie die Leistungen nutzen - ganz nach Ihrem Bedarf. Sie bezahlen nur die Reports, die Sie auch benötigen!
					</p>
				</div>
				<div className={"col s12 xl4"}>
					<h3>Transparent</h3>
					<p>Sie zahlen eine monatliche Grundgebühr von 19,99 Euro zzgl. 19% USt. und nutzungsabhängig pro Recherche, die Sie tatsächlich durchführen. Sie
						haben jederzeit den Überblick und die Kontrolle, wie hoch die monatliche Rechnung ausfällt!</p>
				</div>
				<div className={"col s12 xl4 push-xl8 margin-bottom"}>
					<div className="priceBox current priceTemplate">
						<div className="price white secondary-color-text tRight unset-margin">
							<div className="crossBlock">
								<div className="inlineBlock margin-right">
									<div className="exoLightFont">Angelegte Recherchen</div>
									<span className="value primary-color-text" title="Recherchekosten für diesen Monat">14,97</span><span
									className="additional secondary-color-text"> Euro <span
									className="form-element-required secondary-color-text">*</span></span></div>
								<div className="inlineBlock margin-left">
									<div className="exoLightFont">+ Grundgebühr</div>
									<span className="value primary-color-text" title="Monatliche Grundgebühr">19,99</span><span className="additional secondary-color-text"> Euro <span
									className="form-element-required secondary-color-text">*</span></span></div>
							</div>
							<div className="spacerBlock secondary-color-text">
								<div className="exoLightFont">Monatliches Kostenlimit</div>
								<div className="inline">
									<span className="btn btn-small btn-flat hover-primary-color primary-color-text hover-white-text left"
									      title="Kostenlimit festlegen oder ändern.">
										<Icon iconName={"edit"}/>
									</span>
								</div>
								<div className="inline">
									<span className="btn btn-small btn-flat hover-red red-text hover-white-text left" title="Kostenlimit zurücksetzen.">
										<Icon iconName={"delete"}/>
									</span>
								</div>
								<span className="value primary-color-text">35,00</span>
								<span className="additional secondary-color-text"> Euro <span className="form-element-required secondary-color-text">*</span></span>
							</div>
							<div className="baseFont taxLabel tLeft secondary-color-text"><span className="form-element-required secondary-color-text"> * </span> zzgl. 19% USt.</div>
						</div>
					</div>
				</div>
				<div className={"col s12 xl8 pull-xl4"}>
					<h3>Leistungen</h3>
					<p>Mit der initialen Registrierung eröffnen Sie Ihr Imera Kundenkonto. In der monatlichen Grundgebühr von 19,99 Euro sind folgende Leistungen
						enthalten:</p>
					<ul>
						<li>Kundenkonto: Verwalten Sie Ihre Firmen und Kontodaten!</li>
						<li>Benutzeradministration: Bis zu 10 Benutzer inklusive.</li>
						<li>Recherchenübersicht: Speichern und Archivieren Sie ihre Imera Reports.</li>
						<li>Zugriff auf alle Imera.</li>
					</ul>
				</div>
				
				<div className={"col s12"}>
					{orderableQuestionnaires.length > 0 && <OrderableQuestionnaires questionnaires={orderableQuestionnaires} basicPriceInfo/>}
					<div className={"col s12 spacer"}/>
					
					<Link to={translations.de_DE.routes.registration}>
						<h3 className={"col m8 unset-padding margin-bottom"}>Eröffnen Sie jetzt Ihr Imera Kundenkonto.</h3>
						<div className={"col m4 tRight unset-padding"}>
							<div className={"btn"}>Los geht´s!</div>
						</div>
					</Link>
					
					<div className={"col s12 spacer"}/>
				</div>
			</div>
		</Page>;
		
	} // function render()
	
} // class

export default Prices;